import { VFC } from "react";

import { Skeleton as MuiSkeleton, SkeletonProps } from "@portex-pro/ui-components";
import { IS_STORYBOOK } from "env";

/** Sometimes Skeleton has a zIndex of 1 during animation: @see https://github.com/mui/material-ui/issues/20802 */
const Skeleton: VFC<SkeletonProps> = (props) => <MuiSkeleton {...props} animation={IS_STORYBOOK ? false : undefined} />;

export default Skeleton;
